import React, { useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";

const StudentProfileBarGraph = () => {
  // eslint-disable-next-line
  const [data, setData] = useState([
    {
      name: "Attendance",
      attended: 120,
      leaves: 30,
      totalClasses: 150,
    },
    {
      name: "Page B",
      attended: 95,
      leaves: 45,
      totalClasses: 140,
    },
    {
      name: "Page C",
      attended: 80,
      leaves: 140,
      totalClasses: 220,
    },
    {
      name: "Page D",
      attended: 110,
      leaves: 50,
      totalClasses: 160,
    },
    {
      name: "Page E",
      attended: 75,
      leaves: 100,
      totalClasses: 175,
    },
    {
      name: "Page F",
      attended: 130,
      leaves: 65,
      totalClasses: 195,
    },
    {
      name: "Page G",
      attended: 145,
      leaves: 85,
      totalClasses: 230,
    },
  ]);

  return (
    <ResponsiveContainer width={"100%"} height={300}>
      <BarChart width={500} height={300} data={data && data}>
        <CartesianGrid stroke="#CFCFCF" vertical={false} horizontal={true} />
        <XAxis dataKey="name" stroke="#949596" />
        <YAxis stroke="#949596" />
        <Tooltip
          content={({ payload }) => {
            return (
              <div className="flex-col back-white p-2 radius-6 g-05">
                {payload.map((_data, index) => {
                  console.log(_data);

                  return (
                    <div className="flex-row">
                      <span
                        className="t-14 poppins"
                        style={{ color: _data.fill }}
                      >
                        {_data.dataKey.charAt(0).toUpperCase() +
                          _data.dataKey.slice(1, _data.dataKey.length)}
                        :{" "}
                      </span>
                      <span
                        className="t-14 poppins"
                        style={{ color: _data.fill }}
                      >
                        &nbsp;
                        {_data.payload[_data.dataKey]}
                      </span>
                    </div>
                  );
                })}
              </div>
            );
          }}
        />
        <Bar dataKey="attended" fill="#62B2FD" radius={[6, 6, 0, 0]}>
          <LabelList
            fill="black"
            dataKey="leaves"
            position="top"
            className="poppins t-14"
          />
        </Bar>
        <Bar dataKey="leaves" fill="#9BDFC4" radius={[6, 6, 0, 0]}>
          <LabelList
            className="poppins t-14"
            fill="black"
            dataKey="leaves"
            position="top"
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default StudentProfileBarGraph;
